import { sql } from "drizzle-orm";
import { pgTable, varchar, text, integer, jsonb, timestamp, real, uniqueIndex, type AnyPgColumn } from "drizzle-orm/pg-core";
import type { AdLayer, LayerFontAsset, LayerProviderGeometry, LayerProviderDiagnostic } from "./layered-edit";

// Successful decompositions are insert-only. Mutable admission/recovery
// checkpoints live separately so a restart never replays an uncertain submit.
export const imageLayerDecompositions = pgTable("image_layer_decompositions", {
  id: varchar("id").primaryKey().default(sql`gen_random_uuid()`),
  brandId: varchar("brand_id").notNull(),
  sourceImageHash: text("source_image_hash").notNull(),
  sourceImageUrl: text("source_image_url").notNull(),
  canvasWidth: integer("canvas_width").notNull(),
  canvasHeight: integer("canvas_height").notNull(),
  sourceWidth: integer("source_width").notNull(),
  sourceHeight: integer("source_height").notNull(),
  layersJson: jsonb("layers_json").$type<AdLayer[]>().notNull(),
  fontStylesheets: jsonb("font_stylesheets").$type<LayerFontAsset[]>().notNull(),
  falRequestId: text("fal_request_id").notNull(),
  falLatencyMs: integer("fal_latency_ms"),
  origin: text("origin").notNull().default("bria"),
  parentDecompositionId: varchar("parent_decomposition_id").references((): AnyPgColumn => imageLayerDecompositions.id),
  rendererVersion: text("renderer_version").notNull(),
  baselineDiff: real("baseline_diff").notNull(),
  fontFallback: integer("font_fallback").notNull().default(0),
  createdAt: timestamp("created_at").notNull().defaultNow(),
}, table => [uniqueIndex("image_layer_decompositions_brand_hash").on(table.brandId, table.sourceImageHash)]);

export const imageLayerClaims = pgTable("image_layer_claims", {
  id: varchar("id").primaryKey().default(sql`gen_random_uuid()`),
  brandId: varchar("brand_id").notNull(),
  sourceImageHash: text("source_image_hash").notNull(),
  userId: varchar("user_id").notNull(),
  adId: varchar("ad_id").notNull(),
  sourceImageUrl: text("source_image_url").notNull(),
  state: text("state").notNull().default("reserved"),
  falRequestId: text("fal_request_id"),
  // Server-only result checkpoint; never serialized to the client or logs.
  providerOutput: jsonb("provider_output"),
  providerGeometry: jsonb("provider_geometry").$type<LayerProviderGeometry>(),
  providerDiagnostic: jsonb("provider_diagnostic").$type<LayerProviderDiagnostic>(),
  attempt: integer("attempt").notNull().default(0),
  parentClaimId: varchar("parent_claim_id"),
  leaseOwner: text("lease_owner"),
  leaseExpiresAt: timestamp("lease_expires_at"),
  falLatencyMs: integer("fal_latency_ms"),
  errorCode: text("error_code"),
  createdAt: timestamp("created_at").notNull().defaultNow(),
  updatedAt: timestamp("updated_at").notNull().defaultNow(),
}, table => [
  uniqueIndex("image_layer_claims_brand_hash_attempt").on(table.brandId, table.sourceImageHash, table.attempt),
  uniqueIndex("image_layer_claims_parent").on(table.parentClaimId),
]);
